import { Link } from 'react-router-dom'
import UnControlSwitch from '../Reusable/Form/Switch'
import usePostHook from '../../customHooks/useUserServicePostHook'
import APIS from '../../constant/EndPoint'
import Card from '../Reusable/Card'

const EditRider = (props: any) => {
  const { profile } = props

  const { mutateAsync } = usePostHook({
    queryKey: ["."],
    navigateURL: "",
  });

  const handleUserStatusChange = async () => {
    const url = `${APIS.USER}${profile?.user?.id}/change-active-status/`;
    let formData = {
    };
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <Card>
        <div className='m-2'>

          <table>
            <tbody>

              <tr>
                <td>Name</td>
                <td>:</td>
                <td>{profile?.user.full_name ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>:</td>
                <td>{profile?.user?.email ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Contact Number</td>
                <td>:</td>
                <td>{profile?.user?.mobile_number ?? "N/A"}</td>
              </tr>
            </tbody>
          </table>
          <div className='w-full flex justify-between'>
            <div className='w-[150px] mt-6'>
              <Link to={`/users/edit/${profile?.user}`}>Edit</Link>
            </div>
            <div>
              <UnControlSwitch
                value={profile?.user?.is_active}
                onChange={handleUserStatusChange}

              />
            </div>
          </div>
        </div>
      </Card>
    </>
  )
}

export default EditRider
